import type { MisconceptionDefinition } from '../types';

/** SPR — Klank basis, hoofdletters & leestekens (slice 3). */
export const klankHoofdletterLeestekenMisconceptions: MisconceptionDefinition[] = [{
  id: 'spr.au-ou-verward',
  label: 'Au en ou verward',
  module: 'SpellingRegel',
  description: 'Leerling verwart au-woorden met ou-woorden of omgekeerd (weetwoorden).',
  typicalFamilies: ['SPR-KLANK-AU-OU']
}, {
  id: 'spr.dubbel-klinker-open',
  label: 'Dubbele klinker in open lettergreep',
  module: 'SpellingRegel',
  description: 'Leerling schrijft een dubbele klinker (aa, ee, oo) in een open lettergreep waar één klinker volstaat.',
  typicalFamilies: ['SPR-KLANK-AA-EE-OO']
}, {
  id: 'spr.dubbel-klinker-en-medeklinker',
  label: 'Dubbele klinker én medeklinker',
  module: 'SpellingRegel',
  description: 'Leerling verdubbelt zowel de klinker als de medeklinker (bijv. "maannen" i.p.v. "manen").',
  typicalFamilies: ['SPR-KLANK-AA-EE-OO']
}, {
  id: 'spr.maan-man-verward',
  label: 'Maan/man meervoud verward',
  module: 'SpellingRegel',
  description: 'Leerling verwart het meervoud van "maan" (manen — open lettergreep, lange klank) met het meervoud van "man" (mannen — gesloten lettergreep, korte klank). Klassieke open/gesloten-lettergreep fout op het concrete minimale paar.',
  typicalFamilies: ['SPR-KLANK-AA-EE-OO', 'SPR-KLANK-VERKORTEN']
}, {
  id: 'spr.hoofdletter-dag',
  label: 'Hoofdletter bij dag',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat dagen van de week een hoofdletter krijgen (Engels-invloed).',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-znw',
  label: 'Hoofdletter bij gewoon znw',
  module: 'SpellingRegel',
  description: 'Leerling geeft gewone zelfstandige naamwoorden een hoofdletter (Duits-invloed).',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-ww',
  label: 'Hoofdletter bij werkwoord',
  module: 'SpellingRegel',
  description: 'Leerling geeft werkwoorden onterecht een hoofdletter.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-zinsbegin-vergeten',
  label: 'Hoofdletter zinsbegin vergeten',
  module: 'SpellingRegel',
  description: 'Leerling vergeet de hoofdletter aan het begin van een zin.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-familienaam',
  label: 'Hoofdletter bij familieaanduiding',
  module: 'SpellingRegel',
  description: 'Leerling geeft familieaanduidingen (oma, opa) onterecht een hoofdletter.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-geen-nodig',
  label: 'Denkt geen hoofdletters nodig',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat er geen hoofdletters nodig zijn in een zin.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-zinsbegin-onterecht',
  label: 'Zinsbegin-hoofdletter als fout gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat de hoofdletter aan het zinsbegin onterecht is.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-naam-onterecht',
  label: 'Naam-hoofdletter als fout gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat de hoofdletter bij een persoonsnaam onterecht is.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-plaats-onterecht',
  label: 'Plaats-hoofdletter als fout gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat de hoofdletter bij een plaatsnaam onterecht is.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-land-vergeten',
  label: 'Hoofdletter bij land vergeten',
  module: 'SpellingRegel',
  description: 'Leerling vergeet de hoofdletter bij de naam van een land.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.hoofdletter-taal-vergeten',
  label: 'Hoofdletter bij taal vergeten',
  module: 'SpellingRegel',
  description: 'Leerling vergeet de hoofdletter bij de naam van een taal.',
  typicalFamilies: ['SPR-HOOFDLETTER']
}, {
  id: 'spr.leesteken-punt-ipv-komma',
  label: 'Punt i.p.v. komma',
  module: 'SpellingRegel',
  description: 'Leerling kiest een punt waar een komma past (bij verbonden zinsdelen).',
  typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA']
}, {
  id: 'spr.leesteken-uitroep-verkeerd',
  label: 'Uitroepteken bij mededeling',
  module: 'SpellingRegel',
  description: 'Leerling kiest een uitroepteken bij een gewone mededeling.',
  typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA']
}, {
  id: 'spr.leesteken-dubbele-punt-verkeerd',
  label: 'Dubbele punt verkeerd gebruikt',
  module: 'SpellingRegel',
  description: 'Leerling kiest een dubbele punt waar een komma of punt past.',
  typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA']
}, {
  id: 'spr.leesteken-vraag-ipv-uitroep',
  label: 'Vraagteken bij uitroep',
  module: 'SpellingRegel',
  description: 'Leerling kiest een vraagteken bij een uitroep die begint met een vraagwoord (bijv. "Wat mooi!").',
  typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA']
}, {
  id: 'spr.leesteken-aanhaling-verkeerd',
  label: 'Aanhalingstekens verkeerd geplaatst',
  module: 'SpellingRegel',
  description: 'Leerling plaatst de aanhalingstekens bij directe rede om het verkeerde zinsdeel (bijv. ook om "vroeg Tim" i.p.v. alleen om de letterlijk gesproken woorden).',
  typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA']
}, {
  id: 'spr.leesteken-dubbele-leesteken',
  label: 'Dubbel leesteken in directe rede',
  module: 'SpellingRegel',
  description: 'Leerling zet een extra komma ná een vraag- of uitroepteken in directe rede (bijv. "Kom je?", vroeg hij), terwijl dat eindleesteken de komma al vervangt.',
  typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA']
}];